import {
  FETCH_BOOKINGS,
  FETCH_BOOKINGS_SUCCESS,
  FETCH_BOOKINGS_FAILED,
  UPDATE_BOOKING,
  CANCEL_BOOKING,
  CANCEL_POWERTRANZ_BOOKING_REQUEST,
  CANCEL_POWERTRANZ_BOOKING_SUCCESS,
  CANCEL_POWERTRANZ_BOOKING_FAILURE,
  CLEAR_POWERTRANZ_CANCELLATION,
  FETCH_NEW_BOOKINGS_SUCCESS,
} from "../store/types";

const INITIAL_STATE = {
  bookings: null,
  heatpoints: null,
  active: null,
  tracked: null,
  loading: false,
  // PowerTranz cancellation state
  powertranzCancellation: {
    isProcessing: false,
    result: null,
    error: null,
    bookingId: null
  },
  // Local opened bookings map (not stored in Firebase, only in Redux)
  openedBookings: {}, // { bookingId: true }
  error: {
    flag: false,
    msg: null
  }
}

export const bookingslistreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_BOOKINGS:
      return {
        ...state,
        loading: true
      };
    case FETCH_BOOKINGS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false
      };
    case FETCH_BOOKINGS_FAILED:
      return {
        ...state,
        bookings: null,
        heatpoints: null,
        active:null,
        tracked:null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case FETCH_NEW_BOOKINGS_SUCCESS:
      return {
        ...state,
        heatpoints: action.payload
      };
    case UPDATE_BOOKING:
      return {
        ...state
      }      
    case 'UPDATE_BOOKING_DRIVER_ESTIMATE':
      return {
        ...state
      }
    case CANCEL_BOOKING:
      return {
        ...state
      };
    case 'CANCEL_BOOKING_FOR_AUTO_SEARCH':
      console.log('🔄 Reducer: CANCEL_BOOKING_FOR_AUTO_SEARCH handled');
      return {
        ...state
      };
    case CANCEL_POWERTRANZ_BOOKING_REQUEST:
      return {
        ...state,
        powertranzCancellation: {
          ...state.powertranzCancellation,
          isProcessing: true,
          error: null,
          bookingId: action.payload.bookingId
        }
      };
    case CANCEL_POWERTRANZ_BOOKING_SUCCESS:
      return {
        ...state,
        powertranzCancellation: {
          ...state.powertranzCancellation,
          isProcessing: false,
          result: action.payload.cancellationResult,
          error: null,
          bookingId: action.payload.bookingId
        }
      };
    case CANCEL_POWERTRANZ_BOOKING_FAILURE:
      return {
        ...state,
        powertranzCancellation: {
          ...state.powertranzCancellation,
          isProcessing: false,
          result: null,
          error: action.payload.error,
          bookingId: action.payload.bookingId
        }
      };
    case CLEAR_POWERTRANZ_CANCELLATION:
      return {
        ...state,
        powertranzCancellation: {
          isProcessing: false,
          result: null,
          error: null,
          bookingId: null
        }
      };
    case 'SET_BOOKING_OPENED':
      // Set booking as opened in local Redux state (not Firebase)
      // This flag will be reset when app restarts
      return {
        ...state,
        openedBookings: {
          ...state.openedBookings,
          [action.payload.bookingId]: action.payload.opened
        }
      };
    default:
      return state;
  }
};